module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/mlb/wins-828879d77a49c89983d5a6470bbb0dd0.svg";